import React from 'react';
import Slider from 'rc-slider';
import bandwidthStore from '../store/bandwidth';
import Assumptions from './Assumptions';

const  TabPane = (props)  => {

  const bandwidthState = props.data;
  const wrapperStyle = {  };

  const handleChangeCompute = (val) => {
    bandwidthStore.updateComputeSlider(val);
    bandwidthStore.calculateSliderConstants(bandwidthState.amount);
    bandwidthStore.calculateValues();
    bandwidthStore.calculateTotalValues();
    bandwidthStore.calculateSavings();
  };
  const handleChangeBlock = (val) => {
    bandwidthStore.updateBlockSlider(val);
    bandwidthStore.calculateSliderConstants(bandwidthState.amount);
    bandwidthStore.calculateValues();
    bandwidthStore.calculateTotalValues();
    bandwidthStore.calculateSavings();
  };
  const addCurrencySeparator = (val) => {
    return Math.round(val).toLocaleString(undefined);
  };

  return (
    <div>
      <div>
        <div className="row compareTable">
          <div className="col-xs-4">
            <span className="body1">CPUs/hour</span>
          </div>
          <div className="col-xs-1 right">
            <span className="body1">{(bandwidthState.compute).toLocaleString(undefined)}</span>
          </div>
          <div className="col-xs-5">
            &nbsp;
          </div>
          <div className="col-xs-2 totalColumn">
            &nbsp;
          </div>
        </div>

        <div className="row compareTable">
          <div className="col-xs-5">
            <div style={wrapperStyle} >
              <div className="sliders-marks right">0%</div>
              <Slider min={0} max={100}  defaultValue={50} onChange={e => handleChangeCompute(e)} />
              <div className="sliders-marks left">100%</div>
            </div>
          </div>
          <div className="col-xs-3">
            &nbsp;
          </div>
          <div className="col-xs-2 center azBlue">
            ${addCurrencySeparator(bandwidthState.awsComputeCost)}
          </div>
          <div className="col-xs-2 center totalColumn">
            ${addCurrencySeparator(bandwidthState.ociComputeCost)}
          </div>
        </div>
      </div>

      {bandwidthState.category === 'block' ? <></> 
      : 
      <div>
        <div className="row compareTable">
          <div className="col-xs-4">
            <span className="body1">GB Block Volume (Balanced Perf)</span>
          </div>
          <div className="col-xs-1 right">
            <span className="body1">{(bandwidthState.block).toLocaleString(undefined)}</span>
          </div>
          <div className="col-xs-3">
            &nbsp;
          </div>
          <div className="col-xs-2 center">
            &nbsp;
          </div>
          <div className="col-xs-2 center totalColumn">
            &nbsp;
          </div>
        </div>

        <div className="row compareTable ruleBelowRow">
          <div className="col-xs-5">
            <div style={wrapperStyle} >
              <div className="sliders-marks">0%</div>
              <Slider min={0} max={100} defaultValue={50} onChange={e => handleChangeBlock(e)} />
              <div className="sliders-marks">100%</div>
            </div>
          </div>
          <div className="col-xs-3">
            &nbsp;
          </div>
          <div className="col-xs-2 center azBlue">
            ${addCurrencySeparator(bandwidthState.awsBlockCost)}
          </div>
          <div className="col-xs-2 center totalColumn">
            ${addCurrencySeparator(bandwidthState.ociBlockCost)}
          </div>
        </div>
      </div>
      }

      <div className="row compareTable tcRow">
        <div className="col-xs-8">
          <h5 className="title6 weightBold">Total Cost*</h5>
        </div>
        <div className="col-xs-2 center azBlue title6">
          <p>${addCurrencySeparator(bandwidthState.totalAWSCost)}</p>
        </div>
        <div className="col-xs-2 center totalColumn totalColumnBottom title6">
          <p>${addCurrencySeparator(bandwidthState.totalOCICost)}</p>
        </div>
      </div>
      <div className="row compareTable tcRow">
        <div className="col-xs-6">
          <div className="caption1">DISCLAIMER: The Oracle Cloud Workload Estimator is intended to provide an example of your
            potential savings based on your input. Pricing is based on Oracle's standard published pricing
            for <a href="https://www.oracle.com/cloud/ucpricing.html" target="_blank" rel="noopener noreferrer">Pay As You Go</a> and
            Amazon's standard published on-demand pricing as of May 1, 2020. Oracle Pay As You Go is based on actual usage. This
            calculator tool and its output are intended for information purposes only. Actual savings may vary.</div>
          <Assumptions />
        </div>
        <div className="col-xs-6">
          &nbsp;
        </div>
      </div>
    </div>
  )
};

export default TabPane;